module.exports = __webpack_public_path__ + "img/blasttv-logo.256cb985.png";